module.exports = __webpack_public_path__ + "img/ys_bj_4.33249a6a.png";